
<v-snackbar
  :key="`snack-v2-${message}`"
  v-model="showSnackbar"
  :timeout="timeout"
  :absolute="absolute"
  top
  :color="color"
  :left="left"
  :right="right"
  text
  :class="['snackbar-v2-wrapper', contentClass]"
  @input="toggleToast"
>
  <div class="flex justify-between">
    <div class="title-toast">{{ title || "Inform" }}</div>
    <v-icon @click="closeToast">mdi-close</v-icon>
  </div>
  <div class="break-all">
    <template v-if="message">
      <span v-html="message"> </span>
    </template>
    <component :is="content" v-else />
  </div>
</v-snackbar>
